import { BADGES } from "../constants/constants"

export const getBadgeImageByPath = (year, pathname) => {
  const yearBadges = BADGES[year]
  if (!yearBadges) return null

  const match = yearBadges.find(badge => badge.pageSlug === pathname)
  return match?.image || null
}
